export const INCREMENTABLE_DISH_TYPES = ['dessert', 'cheese', 'bread'];